export const growth = [
    {month: 'Jan', price: 100},
    {month: 'Feb', price: 4000},
    {month: 'Mar', price: 1200},
    {month: 'Apr', price: 3000},
    {month: 'May', price: 6000},
];
